var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDim(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 90,
    viewBox: "0 0 119 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M107.844 90H11.1562C4.99475 90 0 84.9633 0 78.75V11.25C0 5.03672 4.99475 0 11.1562 0H107.844C114.005 0 119 5.03672 119 11.25V78.75C119 84.9633 114.005 90 107.844 90ZM26.0312 13.125C18.8429 13.125 13.0156 19.0013 13.0156 26.25C13.0156 33.4987 18.8429 39.375 26.0312 39.375C33.2196 39.375 39.0469 33.4987 39.0469 26.25C39.0469 19.0013 33.2196 13.125 26.0312 13.125ZM14.875 75H104.125V48.75L83.7846 28.2387C82.6955 27.1404 80.9295 27.1404 79.8402 28.2387L48.3438 60L35.4408 46.9887C34.3517 45.8904 32.5858 45.8904 31.4964 46.9887L14.875 63.75V75Z",
    fill: "#F8F8F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDim);
export default __webpack_public_path__ + "static/media/dim.e2a1c558d32f1b3dc9d8aec612f987ee.svg";
export { ForwardRef as ReactComponent };